import { MasterUI } from "../common/MasterUI";
import { LoadingView, LoadingViewProps } from "./LoadingView";

export type AppLoadingViewProps = Omit<LoadingViewProps, "fullscreen">;

/**
 * In-app variant of LoadingView that renders inside MasterUI, so the topbar
 * and content area match what the real pages show. Use this everywhere the
 * MasterRouteContainer / PageProvider / AppStore are mounted; the canvas
 * lives in the same area as on the destination page, which keeps the
 * AnimatedBackground orbs from jumping when the loading screen swaps in.
 *
 * Use the bare LoadingView for boot-time states (before AppStoreProvider
 * has mounted) — MasterUI relies on the app store and would crash there.
 */
export const AppLoadingView = (props: AppLoadingViewProps) => (
  <MasterUI>
    <LoadingView {...props} />
  </MasterUI>
);
